var map = {
	"./copy-dark.png": "4399",
	"./copy-success.png": "2b91",
	"./copy.png": "89c1",
	"./discord-dark.png": "cee8",
	"./discord.png": "e80d",
	"./facebook-dark.png": "bca5",
	"./facebook.png": "91ab",
	"./linkedin-dark.png": "bb6f",
	"./linkedin.png": "7a62",
	"./telegram-dark.png": "aac4",
	"./telegram.png": "1369",
	"./twitter-dark.png": "6d81",
	"./twitter.png": "2b7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4fa";